// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__29WX3","type":"styles_type__1_-sk","choices":"styles_choices__4j54S"};